import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "@/stores";
import { MemberRead } from "./types";

interface TenantMemberState {
  loading: boolean;
  members: MemberRead[];
}

const initialState: TenantMemberState = {
  loading: false,
  members: [],
};

export const tenantMemberSelects = {
  loading: (state: RootState) => state.tenantMember.loading,
  members: (state: RootState) => state.tenantMember.members,
};

export const tenantMemberThunks = {
  list: createAsyncThunk("tenantMember/list", () => {
    // const res = await TransferService.list({
    //   ...params,
    //   category: TransferCategory.TenantDeposit,
    // }).run();

    // return res.data.msg;
    return {
      members: [
        {
          id: "01234567789",
          username: "test-user-1",
          name: "測試用戶一",
          address: "1A1zP1eP5QGefi2DMPTfTL5SLmv7DivfNa",
          created_at: "2024-01-26T22:50:00Z",
        },
      ],
    };
  }),
};

export const tenantMemberSlice = createSlice({
  name: "tenantMember",
  initialState,
  reducers: {
    // setQueryParams: (state, action: PayloadAction<TransferQueryParams>) => {
    //   state.queryParams = action.payload;
    // },
  },
  extraReducers: (builder) => {
    builder.addCase(tenantMemberThunks.list.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(tenantMemberThunks.list.fulfilled, (state, action) => {
      state.loading = false;
      state.members = action.payload.members;
    });
    builder.addCase(tenantMemberThunks.list.rejected, (state) => {
      state.loading = false;
      state.members = [];
    });
  },
});

export const tenantMemberActions = tenantMemberSlice.actions;
